import React, { Component, useState, useEffect } from "react";

import Modal from "react-bootstrap/Modal";
import { InputGroup } from "react-bootstrap";

import moment from "moment";

import ContractView from "./List/View.js";
import ContractControlBtn from "../Component/ContractControlBtn.js";
import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";
import * as commonData from "@app/lib/common_data";

import NurseryList from "../Component/NurseryList";
import ContractStatSummary from "../Component/ContractStatSummary";
import SearchNurseryModal from "../Component/SearchNurseryModal";

import NurseryInfoTable from "../Component/NurseryInfoTable";

const Tas4Branch = (props) => {
    const [serviceAppList, setServiceAppList] = useState(null);
    const [appAuthTypeList, setAppAuthTypeList] = useState(null);
    const [seasonInfo, setSeasonInfo] = useState(false);
    useEffect(() => {
        if (!serviceAppList && !seasonInfo) {
            getBaseInfo();
        }
        return () => {};
    }, [props.branch_id, props.query]);

    const getBaseInfo = () => {
        commonData.getAppAuthTypeList(axios, (err, typeList) => {
            if (!err) {
                setAppAuthTypeList(typeList);
                commonData.getServiceAppList(axios, (err, appList) => {
                    if (!err) {
                        setServiceAppList(appList);
                        commonData.getSeasonInfo(axios, (err, seasonInfo) => {
                            if (!err) {
                                setSeasonInfo(seasonInfo);
                            }
                        });
                    }
                });
            } else {
            }
        });
    };

    if (!seasonInfo || !serviceAppList || !appAuthTypeList) {
        return <></>;
    }

    const { history, branch_id, query } = props;
    if (query.type === "view") {
        return <Detail history={history} branch_id={branch_id} query={query} serviceAppList={serviceAppList} appAuthTypeList={appAuthTypeList} seasonInfo={seasonInfo} />;
    } else {
        return <List history={history} branch_id={branch_id} query={query} serviceAppList={serviceAppList} appAuthTypeList={appAuthTypeList} seasonInfo={seasonInfo} />;
    }
};

const List = ({ history, branch_id, query, serviceAppList, appAuthTypeList, seasonInfo }) => {
    const [searchModal, showSearchModal] = useState(false);
    const [selectedNursery, setSelectNursery] = useState(null);
    const [selectedAppContractType, setSelectedAppContractType] = useState({ app_id: null, contract_type: null });

    useEffect(() => {
        return () => {};
    }, [branch_id, query]);

    const detailPage = (id) => {
        document.location.href = "?type=view&id=" + id;
        // history.go('?type=view&id=' + id);
    };

    const submitData = (data) => {
        axios({
            method: "post",
            url: `${Constant.API_DOMAIN}/api/nursery/info`,
            data: {
                branchId: branch_id,
                ...data,
            },
        })
            .then((res) => {
                detailPage(res.data.nurseryId);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const yearSummary = seasonInfo.recontractYear;
    if(!serviceAppList || !appAuthTypeList || !seasonInfo) {
        return <></>;
    }

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">계약 관리</h2>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
                            {seasonInfo.isRecontractSeason && (
                                <h5 className="mb-0 text-danger">
                                    ※ {moment(seasonInfo.recontractStart, "YYYY-MM-DD").format("YYYY.MM.DD")}~{moment(seasonInfo.recontractEnd, "YYYY-MM-DD").format("YYYY.MM.DD")}까지 재계약(계약
                                    갱신) 기간입니다.&nbsp;기간 내에 갱신 바랍니다.
                                </h5>
                            )}
                            {seasonInfo.isNoContractSeason && (
                                <h5 className="mb-0 text-danger">
                                    ※ {moment(seasonInfo.noContractStart, "YYYY-MM-DD").format("YYYY.MM.DD")}~{moment(seasonInfo.noContractEnd, "YYYY-MM-DD").format("YYYY.MM.DD")}까지 미사용 처리 가능
                                    기간입니다.&nbsp;해당 기간 이외에는 미사용 처리가 불가능 하오니, 반드시 기간 내에 미사용 처리를 진행해 주세요.
                                </h5>
                            )}
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                            <SearchNurseryModal
                                show={searchModal}
                                setShow={(show) => showSearchModal(show)}
                                selectData={(data) => {
                                    if (window.confirm(`${data.name}의 계약을 등록합니다.\n계속 하시겠습니까?`)) {
                                        submitData(data);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content pb-1">
                    <ContractStatSummary
                        branch_id={branch_id}
                        year={yearSummary}
                        serviceAppList={serviceAppList}
                        appAuthTypeList={appAuthTypeList}
                        selectedAppContractType={selectedAppContractType}
                        setSelectedAppContractType={setSelectedAppContractType}
                    />
                </div>
                <div className="container-fluid dashboard-content pt-0">
                    <NurseryList
                        branch_id={branch_id}
                        query={query}
                        detailFunc={detailPage}
                        serviceAppList={serviceAppList}
                        appAuthTypeList={appAuthTypeList}
                        seasonInfo={seasonInfo}
                        selectedAppContractType={selectedAppContractType}
                    />
                </div>
            </div>
            <Modal size="sm" show={selectedNursery !== null} onHide={() => setSelectNursery(null)} aria-labelledby="example-custom-modal-styling-title">
                <Modal.Body>
                    <strong className="text-danger pr-2">{selectedNursery ? selectedNursery.name : ""}</strong>
                    원에 계약을 등록하시겠습니까?
                    <div className="row mt-5">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <button className="btn btn-primary btn-block" onClick={submitData}>
                                확인
                            </button>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <button
                                className="btn btn-danger btn-block"
                                onClick={() => {
                                    setSelectNursery(null);
                                    showSearchModal(true);
                                }}
                            >
                                취소
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

const Detail = ({ branch_id, query, seasonInfo, serviceAppList, appAuthTypeList }) => {
    const [loadingData, setLoadingData] = useState(true);
    const [data, setData] = useState(null);
    const [contractList, setContractList] = useState(null);
    const [director, setDirector] = useState(null);
    const [bizApp, setBizApp] = useState([]);

    const CONTRACT_TABLE_ID = "contractInfoTable";

    useEffect(() => {
        if (query.id) {
            if (!data || query.id !== data.id) {
                getDetailData(query.id);
            }

            if (!contractList || !bizApp || (data && query.id !== data.id)) {
                getContractList(query.id);
            }
        }
        return () => {};
    }, [branch_id, query.id]);
    useEffect(() => {}, [contractList]);

    const getDetailData = (id) => {
        setLoadingData(true);
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/nursery/info/${branch_id}/${id}`,
        })
            .then((res) => {
                setData(res.data.nursery);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };

    const getContractList = (id) => {
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/contract/list/${branch_id}/${id}`,
        })
            .then((res) => {
                const bizApp = {};
                const list = res.data && res.data.contract ? res.data.contract : [];
                res.data.bizApp.forEach((app) => {
                    bizApp[app] = { id: app, hasPreContractedBranch: false };
                    bizApp[app].info = serviceAppList.find((sa) => sa.key == app);
                    bizApp[app].authTypeList = appAuthTypeList[app];
                });
                if (res.data.nurseryAppBranch && res.data.nurseryAppBranch.length > 0) {
                    res.data.nurseryAppBranch.forEach((appContractBranch) => {
                        if (appContractBranch.app_id != "homebooks" && bizApp[appContractBranch.app_id]) {
                            if (!bizApp[appContractBranch.app_id].hasPreContractedBranch) {
                                bizApp[appContractBranch.app_id].hasPreContractedBranch = appContractBranch.branch_id != branch_id;
                            }
                        }
                    });
                }
                // 기존 계약 승인 정보 보관
                list.forEach((c) => {
                    if (c.app_auth) {
                        let allNA = true;
                        serviceAppList.forEach((a) => {
                            if(a.contractUseTas && bizApp[a.key]) {
                                if(c.app_auth[a.key]) {
                                    c.app_auth[a.key].approval_org = c.app_auth[a.key].approval;
                                    c.app_auth[a.key].authType_org = c.app_auth[a.key].authType;
                                    c.app_auth[a.key].authTypeName_org = c.app_auth[a.key].authTypeName;
                                    c.app_auth[a.key].authTypeId_org = c.app_auth[a.key].authTypeId;
                                    // 해지된 계약 경우 연령 초기화
                                    if (c.app_auth[a.key].approval == "NA") {
                                        c[bizApp[a.key].info.age.field] = c.age;
                                        // 단독 수량 사용 시 수량 초기화
                                        if(bizApp[a.key].info.hasCellQuantity) {
                                            bizApp[a.key].info.quantity.field.forEach((q) => c[q] = 0);
                                        }
                                    } else {
                                        // 공통 수량 사용여부 체크
                                        if(!bizApp[a.key].info.hasCellQuantity) {
                                            allNA = false;
                                        }
                                    }
                                }
                                // 결합 상품 정보 설정
                                if(c.unionId) {
                                    c.unionSelected = appAuthTypeList.all.find((at) => at.id == c.unionId);
                                }
                            }
                        });
                        // 공통 수량 사용하는 서비스 모두 해지된 경우 수량 초기화
                        if (allNA) {
                            bizApp.tomonote.info.quantity.field.forEach((q) => c[q] = 0);
                        }
                    }
                });
                list.sort((a, b) => (a.is555 == b.is555 ? (a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age) : a.is555 ? 1 : -1));
                setDirector(res.data.director);
                setBizApp(bizApp);
                setContractList(list);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    window.onbeforeunload = () => {
        if (window.changeMemoData && window.changeMemoData()) {
            return true;
        }
    };
    if (!data) return null;

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                            <div className="page-header">
                                <h2 className="pageheader-title">{data ? data.name : "-"}</h2>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-right mb-2">
                            <button className="btn btn-rounded btn-primary" onClick={() => (document.location.href = "?type=")}>
                                목록
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <div className="row mt-2">
                        <div className="col">
                            <h3 className="">원 정보</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mt-1">
                            <NurseryInfoTable nursery={data} editBtn={1} />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mt-1">
                            {data && <BranchMemoForm nu_id={data.id} branch_id={branch_id} memo={data.memo && data.memo.length > 0 ? data.memo[0] : null} />}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <h3 className="mt-3 mb-1">계약 정보</h3>
                        </div>
                    </div>

                    {(seasonInfo.isRecontractSeason || seasonInfo.isNoContractSeason) && (
                        <div className="row mb-0">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                {seasonInfo.isRecontractSeason && (
                                    <h5 className="mb-0">
                                        <span className="text-danger">
                                            ※ {moment(seasonInfo.recontractStart).format("YYYY/MM/DD")} ~ {moment(seasonInfo.recontractEnd).format("YYYY/MM/DD")}까지 재계약(계약 갱신)
                                            기간입니다.&nbsp;
                                        </span>
                                        기간 내에 [계약 수정] 화면에서 재계약을 진행해 주세요.
                                    </h5>
                                )}
                                {seasonInfo.isNoContractSeason && (
                                    <h5 className="mb-0">
                                        <span className="text-danger">
                                            ※ {moment(seasonInfo.noContractStart).format("MM/DD")}~{moment(seasonInfo.noContractEnd).format("MM/DD")}까지 미사용 처리 가능 기간입니다.&nbsp;
                                        </span>
                                        해당 기간 이외에는 미사용 처리가 불가능 하오니, 반드시 기간 내에 미사용 처리를 진행해 주세요.
                                    </h5>
                                )}
                            </div>
                        </div>
                    )}

                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 bg-light" style={{ overflow: "auto" }}>
                            <ContractView.ContractViewBranch
                                tableId={CONTRACT_TABLE_ID}
                                bizApp={bizApp}
                                serviceAppList={serviceAppList}
                                appAuthTypeList={appAuthTypeList}
                                list={contractList}
                                changeList={(newList) => {
                                    setContractList(newList);
                                }}
                                director={director}
                                nurseryName={data.name || ""}
                                isRecontractSeason={seasonInfo.isRecontractSeason}
                                seasonInfo={seasonInfo}
                            />
                        </div>
                    </div>
                    <ContractControlBtn
                        branchId={branch_id}
                        nurseryId={query.id}
                        nurseryName={data.name}
                        nurseryStatus={data.status}
                        directorName={data.director}
                        address={data.address}
                        tableId={CONTRACT_TABLE_ID}
                        list={contractList}
                        director={director}
                        bizApp={bizApp}
                        serviceAppList={serviceAppList}
                        appAuthTypeList={appAuthTypeList}
                        seasonInfo={seasonInfo}
                        isRecontractModal={false}
                        isBranchCall={true}
                    />
                </div>
            </div>
        </div>
    );
};

const MEMO_DEFAULT_VAL = {
    director_mobile: "",
    charger: "",
    charger_mobile: "",
    memo: "",
};

const BranchMemoForm = ({ nu_id, branch_id, memo }) => {
    const [data, setData] = useState(null);
    const [doingSubmit, setDoingSubmit] = useState(false);

    useEffect(() => {
        if (memo) {
            setData(memo);
        } else {
            setData(MEMO_DEFAULT_VAL);
        }
        return () => {};
    }, [nu_id, branch_id, memo]);

    const changeHandler = (e) => {
        const { name, value } = e.target;
        const _data = { ...data };
        _data[name] = value;
        setData(_data);
    };

    const submitMemoForm = () => {
        if (!changeMemoData()) {
            alert("변경된 값이 없습니다.");
            return;
        }

        setDoingSubmit(true);

        axios({
            method: "post",
            url: `${Constant.API_DOMAIN}/api/nursery/memo/${nu_id}`,
            data: {
                ...data,
                branchId: branch_id,
            },
        })
            .then((res) => {
                setDoingSubmit(false);
                alert("저장되었습니다.");
                // document.location.reload();
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setDoingSubmit(false);
            });
    };

    const changeMemoData = () => {
        if (memo) {
            return !(data.director_mobile == memo.director_mobile && data.charger == memo.charger && data.charger_mobile == memo.charger_mobile && data.memo == memo.memo);
        } else {
            return data.director_mobile || data.charger || data.charger_mobile || data.memo;
        }
    };

    window.changeMemoData = changeMemoData;

    if (data) {
        return (
            <div className="card">
                <div className="card-body pr-2 pl-2 pt-1 pb-0">
                    <h5 className="ml-2 mt-1 mb-3">원 관리 정보</h5>
                    <div className="pl-3 pr-3">
                        <label htmlFor="director_mobile">원장 휴대전화번호</label>
                        <input type="text" className="form-control mb-1 p-1" id="director_mobile" name="director_mobile" value={data.director_mobile || ""} onChange={changeHandler} />
                        <label htmlFor="charger">담당교사</label>
                        <input type="text" className="form-control mb-1 p-1" id="charger" name="charger" value={data.charger || ""} onChange={changeHandler} />
                        <label htmlFor="charger_mobile">담당교사 휴대전화번호</label>
                        <input type="text" className="form-control mb-1 p-1" id="charger_mobile" name="charger_mobile" value={data.charger_mobile || ""} onChange={changeHandler} />
                        <label htmlFor="memo">기타 메모</label>
                        <textarea className="form-control mb-1 p-1" id="memo" name="memo" value={data.memo || ""} onChange={changeHandler} rows={3} />
                    </div>
                </div>
                <div className="card-body mt-1 pt-0 pb-1 mb-1">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"></div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-right">
                            <button
                                className="btn btn-grey btn-rounded mr-2 font-14"
                                onClick={() => {
                                    setData(memo);
                                }}
                            >
                                취소
                            </button>
                            <button className="btn btn-brand btn-rounded font-14" onClick={submitMemoForm} disabled={doingSubmit}>
                                저장
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
};

export default Tas4Branch;
